module.exports = __webpack_public_path__ + "static/newtestament2wjoseph-6072ca3ba6b3f5bdbad63b1d8b538d9b.jpg";